import { DeliveryModel, Journey } from '@audibene/ta.utils-opportunity'

const JOURNEY_TO_DELIVERY_MODEL: Record<Journey, DeliveryModel> = {
  [Journey.DIRECT_TO_CONSUMER_STANDARD]: DeliveryModel.DIRECT_TO_CONSUMER,

  [Journey.NETWORK_BEST_CHOICE]: DeliveryModel.NETWORK,
  [Journey.NETWORK_DIRECT_SALE]: DeliveryModel.NETWORK,
  [Journey.NETWORK_HEAR_TODAY]: DeliveryModel.NETWORK,
  [Journey.NETWORK_ECONOMY]: DeliveryModel.NETWORK,
  [Journey.NETWORK_MEDICAL_ADVANTAGE]: DeliveryModel.NETWORK,
  [Journey.NETWORK_MEDICARE_ADVANTAGE]: DeliveryModel.NETWORK,
  [Journey.NETWORK_STANDARD]: DeliveryModel.NETWORK,
  [Journey.NETWORK_TRUHEARING]: DeliveryModel.NETWORK,
  [Journey.NETWORK_YOUNG_HEARING_AID]: DeliveryModel.NETWORK,

  [Journey.NETWORK_HOME_DELIVERY_BEST_CHOICE]: DeliveryModel.NETWORK_HOME_DELIVERY,
  [Journey.NETWORK_HOME_DELIVERY_HEAR_TODAY]: DeliveryModel.NETWORK_HOME_DELIVERY,
  [Journey.NETWORK_HOME_DELIVERY_MEDICARE_ADVANTAGE]: DeliveryModel.NETWORK_HOME_DELIVERY,
  [Journey.NETWORK_HOME_DELIVERY_STANDARD]: DeliveryModel.NETWORK_HOME_DELIVERY,
  [Journey.NETWORK_HOME_DELIVERY_TRUHEARING]: DeliveryModel.NETWORK_HOME_DELIVERY,
  [Journey.NETWORK_HOME_DELIVERY_YOUNG_HEARING_AID]: DeliveryModel.NETWORK_HOME_DELIVERY,

  [Journey.TELEAUDIOLOGY_BEST_CHOICE]: DeliveryModel.TELEAUDIOLOGY,
  [Journey.TELEAUDIOLOGY_ECONOMY]: DeliveryModel.TELEAUDIOLOGY,
  [Journey.TELEAUDIOLOGY_HEAR_TODAY]: DeliveryModel.TELEAUDIOLOGY,
  [Journey.TELEAUDIOLOGY_RETAIL]: DeliveryModel.TELEAUDIOLOGY,
  [Journey.TELEAUDIOLOGY_YOUNG_HEARING_AID]: DeliveryModel.TELEAUDIOLOGY,
  [Journey.TELEAUDIOLOGY_MEDICAL_ADVANTAGE]: DeliveryModel.TELEAUDIOLOGY,
  [Journey.TELEAUDIOLOGY_MEDICARE_ADVANTAGE]: DeliveryModel.TELEAUDIOLOGY,
  [Journey.TELEAUDIOLOGY_STANDARD]: DeliveryModel.TELEAUDIOLOGY,
  [Journey.TELEAUDIOLOGY_TRUHEARING]: DeliveryModel.TELEAUDIOLOGY,

  [Journey.TA_LIGHT_BEST_CHOICE]: DeliveryModel.TA_LIGHT,
  [Journey.TA_LIGHT_ECONOMY]: DeliveryModel.TA_LIGHT,
  [Journey.TA_LIGHT_HEAR_TODAY]: DeliveryModel.TA_LIGHT,
  [Journey.TA_LIGHT_MEDICARE_ADVANTAGE]: DeliveryModel.TA_LIGHT,
  [Journey.TA_LIGHT_OVER_THE_COUNTER]: DeliveryModel.TA_LIGHT,
  [Journey.TA_LIGHT_STANDARD]: DeliveryModel.TA_LIGHT,
  [Journey.TA_LIGHT_TRUHEARING]: DeliveryModel.TA_LIGHT,

  [Journey.TA_ONSITE_BEST_CHOICE]: DeliveryModel.TA_ONSITE,
  [Journey.TA_ONSITE_ECONOMY]: DeliveryModel.TA_ONSITE,
  [Journey.TA_ONSITE_HEAR_TODAY]: DeliveryModel.TA_ONSITE,
  [Journey.TA_ONSITE_MEDICARE_ADVANTAGE]: DeliveryModel.TA_ONSITE,
  [Journey.TA_ONSITE_OVER_THE_COUNTER]: DeliveryModel.TA_ONSITE,
  [Journey.TA_ONSITE_STANDARD]: DeliveryModel.TA_ONSITE,
  [Journey.TA_ONSITE_TRUHEARING]: DeliveryModel.TA_ONSITE,
}

const getDeliveryModelFromJourney = (journey: string | undefined): DeliveryModel | undefined => {
  if (!journey) return undefined
  return JOURNEY_TO_DELIVERY_MODEL[journey as Journey]
}

export { getDeliveryModelFromJourney }
